"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let ReplaceMeter = class ReplaceMeter extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "modal",
    };
    beforeCreate() {
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    formId;
    labelAlign;
    item;
    async $$load_item() {
        return this.$fn.schemaDefaults('ReplaceMeter');
    }
    responseData;
    workflowStepsInfo;
    units;
    async $$load_units() {
        return this.$fn.fetch('get_meter_type_units');
    }
    selectedOldMeter;
    old_reading_image;
    new_reading_image;
    ux;
    b_4963030162390099_dataSource;
    b_4246589045129675_dataSource;
    dataMembers = ['formId', 'labelAlign', 'item', 'responseData', 'workflowStepsInfo', 'units', 'selectedOldMeter', 'old_reading_image', 'new_reading_image', 'ux', 'b_4963030162390099_dataSource', 'b_4246589045129675_dataSource'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                formId: null,
                labelAlign: "right",
                item: null,
                responseData: null,
                workflowStepsInfo: {
                    steps: ["rögzíti a leszerelt mérőóra állását",
                        "inaktiválja a leszerelt órát",
                        "inaktiválja a kapcsolódó bérleménynél beállított mért szolgáltatást",
                        "létrehoz egy új mérőórát a megadott sorozatszámmal",
                        "rögzíti az induló mérőállást",
                        "a kapcsolódó bérleménynél a leszerelt mérőóra helyett beállít egy mért szolgáltatást az új mérőórával",
                    ],
                },
                units: null,
                selectedOldMeter: null,
                old_reading_image: null,
                new_reading_image: null,
                ux: null,
                b_4963030162390099_dataSource: {
                    name: "suggest_meter",
                    parameters: {
                        exclude_types: ["pulse",
                        ],
                    },
                },
                b_4246589045129675_dataSource: {
                    name: "suggest_meter",
                    parameters: {
                        exclude_types: ["pulse",
                        ],
                    },
                },
            },
        };
    }
    get isReadOnly() {
        if (this.loaded) {
            return !!(this.responseData || (this.actions.submit && this.actions.submit.isRunning));
        }
        return null;
    }
    get oldMeterReadingUnitOptions() {
        if (this.loaded) {
            return this.selectedOldMeter ? this.units[this.selectedOldMeter.meter_type] : [];
        }
        return null;
    }
    get document() {
        if (this.loaded) {
            return {
                title: this.$fn.pgettext("ReplaceMeterModal.Title", "Replace Meter"),
            };
        }
        return null;
    }
    async act_7315092382398562_closeModal_4496_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                cancel: true,
            },
        };
    }
    async evh_7315092382398562_close(event, scope) {
        return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
    }
    async evh_2248226175642056_close(event, scope) {
        return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
    }
    async act_1040167445267876_setData_4502_getActionArgs($event) {
        return {
            path: "responseData",
            value: $event.data.response.data,
            resolve: false,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async act_1040167445267876_request_4500_getActionArgs($event) {
        return {
            operation: "create_meter_operation",
            data: this.item,
            parameters: {
                op: "replacement",
            },
        };
    }
    async evh_1040167445267876_submit(event, scope) {
        return await this.actions.evh_1040167445267876_submit.executeFromDOM(this, event, scope);
    }
    async act_4963030162390099_setData_4504_getActionArgs($event) {
        return {
            path: "item.old_meter.unit",
            value: $event.data.option.unit,
            resolve: false,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async act_4963030162390099_setData_4506_getActionArgs($event) {
        return {
            path: "selectedOldMeter",
            value: $event.data.option,
            resolve: false,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async evh_4963030162390099_optionSelected(event, scope) {
        return await this.actions.evh_4963030162390099_optionSelected.executeFromDOM(this, event, scope);
    }
    async act_3855552110905499_setData_4508_getActionArgs($event) {
        return {
            path: "item.old_meter.image",
            value: this.$fn.imageData($event.value),
            resolve: true,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async evh_3855552110905499_changed(event, scope) {
        return await this.actions.evh_3855552110905499_changed.executeFromDOM(this, event, scope);
    }
    async act_4246589045129675_setData_4510_getActionArgs($event) {
        return {
            path: "item.new_meter.serial",
            value: $event.data.option.serial_number,
            resolve: false,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async act_4246589045129675_setData_4510_getWhen($event) {
        return $event.data.option;
    }
    async act_4246589045129675_setData_4512_getActionArgs($event) {
        return {
            path: "item.new_meter.id",
            value: $event.data.option.id,
            resolve: false,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async act_4246589045129675_setData_4512_getWhen($event) {
        return $event.data.option;
    }
    async act_4246589045129675_setData_4514_getActionArgs($event) {
        return {
            path: "item.new_meter.unit",
            value: $event.data.option.unit,
            resolve: false,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async act_4246589045129675_setData_4514_getWhen($event) {
        return $event.data.option;
    }
    async evh_4246589045129675_optionSelected(event, scope) {
        return await this.actions.evh_4246589045129675_optionSelected.executeFromDOM(this, event, scope);
    }
    async evh_353388685162594_clickPreventStop(event, scope) {
        return await this.actions.evh_353388685162594_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async evh_1548630417156826_clickPreventStop(event, scope) {
        return await this.actions.evh_1548630417156826_clickPreventStop.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_closeModal_4496 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_7315092382398562_closeModal_4496_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_close_4495 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_closeModal_4496,
            event: "close",
            displayName: "closeModal",
        });
        const evh_7315092382398562_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_close_4495],
        });
        const act_2248226175642056_closeComponent_4498 = new core_1.actions.CloseComponentAction({
            events: [],
        });
        const evh_2248226175642056_close_4497 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_closeComponent_4498,
            event: "close",
            displayName: "closeComponent",
        });
        const evh_2248226175642056_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_close_4497],
        });
        const act_1040167445267876_setData_4502 = new core_1.actions.SetDataAction({
            actionArgs: this.act_1040167445267876_setData_4502_getActionArgs,
            events: [],
        });
        const evh_1040167445267876_success_4501 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_setData_4502,
            event: "success",
            displayName: "setData",
        });
        const act_1040167445267876_request_4500 = new core_1.actions.RequestAction({
            actionArgs: this.act_1040167445267876_request_4500_getActionArgs,
            displayName: "submit",
            events: [evh_1040167445267876_success_4501],
        });
        const evh_1040167445267876_submit_4499 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_request_4500,
            event: "submit",
            displayName: "submit",
        });
        const evh_1040167445267876_submit = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1040167445267876_submit_4499],
        });
        const act_4963030162390099_setData_4504 = new core_1.actions.SetDataAction({
            actionArgs: this.act_4963030162390099_setData_4504_getActionArgs,
            events: [],
        });
        const evh_4963030162390099_optionSelected_4503 = new core_1.actions.EventHandlerImpl({
            action: act_4963030162390099_setData_4504,
            event: "optionSelected",
            displayName: "setData",
        });
        const act_4963030162390099_setData_4506 = new core_1.actions.SetDataAction({
            actionArgs: this.act_4963030162390099_setData_4506_getActionArgs,
            events: [],
        });
        const evh_4963030162390099_optionSelected_4505 = new core_1.actions.EventHandlerImpl({
            action: act_4963030162390099_setData_4506,
            event: "optionSelected",
            displayName: "setData",
        });
        const evh_4963030162390099_optionSelected = new core_1.actions.EventHandlerGroup({
            handlers: [evh_4963030162390099_optionSelected_4503, evh_4963030162390099_optionSelected_4505],
        });
        const act_3855552110905499_setData_4508 = new core_1.actions.SetDataAction({
            actionArgs: this.act_3855552110905499_setData_4508_getActionArgs,
            events: [],
        });
        const evh_3855552110905499_changed_4507 = new core_1.actions.EventHandlerImpl({
            action: act_3855552110905499_setData_4508,
            event: "changed",
            displayName: "setData",
        });
        const evh_3855552110905499_changed = new core_1.actions.EventHandlerGroup({
            handlers: [evh_3855552110905499_changed_4507],
        });
        const act_4246589045129675_setData_4510 = new core_1.actions.SetDataAction({
            actionArgs: this.act_4246589045129675_setData_4510_getActionArgs,
            when: this.act_4246589045129675_setData_4510_getWhen,
            events: [],
        });
        const evh_4246589045129675_optionSelected_4509 = new core_1.actions.EventHandlerImpl({
            action: act_4246589045129675_setData_4510,
            event: "optionSelected",
            displayName: "setData",
        });
        const act_4246589045129675_setData_4512 = new core_1.actions.SetDataAction({
            actionArgs: this.act_4246589045129675_setData_4512_getActionArgs,
            when: this.act_4246589045129675_setData_4512_getWhen,
            events: [],
        });
        const evh_4246589045129675_optionSelected_4511 = new core_1.actions.EventHandlerImpl({
            action: act_4246589045129675_setData_4512,
            event: "optionSelected",
            displayName: "setData",
        });
        const act_4246589045129675_setData_4514 = new core_1.actions.SetDataAction({
            actionArgs: this.act_4246589045129675_setData_4514_getActionArgs,
            when: this.act_4246589045129675_setData_4514_getWhen,
            events: [],
        });
        const evh_4246589045129675_optionSelected_4513 = new core_1.actions.EventHandlerImpl({
            action: act_4246589045129675_setData_4514,
            event: "optionSelected",
            displayName: "setData",
        });
        const evh_4246589045129675_optionSelected = new core_1.actions.EventHandlerGroup({
            handlers: [evh_4246589045129675_optionSelected_4509, evh_4246589045129675_optionSelected_4511, evh_4246589045129675_optionSelected_4513],
        });
        const act_353388685162594_closeComponent_4516 = new core_1.actions.CloseComponentAction({
            events: [],
        });
        const evh_353388685162594_clickPreventStop_4515 = new core_1.actions.EventHandlerImpl({
            action: act_353388685162594_closeComponent_4516,
            event: "click.prevent.stop",
            displayName: "closeComponent",
        });
        const evh_353388685162594_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_353388685162594_clickPreventStop_4515],
        });
        const act_1548630417156826_closeComponent_4518 = new core_1.actions.CloseComponentAction({
            events: [],
        });
        const evh_1548630417156826_clickPreventStop_4517 = new core_1.actions.EventHandlerImpl({
            action: act_1548630417156826_closeComponent_4518,
            event: "click.prevent.stop",
            displayName: "closeComponent",
        });
        const evh_1548630417156826_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1548630417156826_clickPreventStop_4517],
        });
        return {
            act_7315092382398562_closeModal_4496,
            evh_7315092382398562_close_4495,
            evh_7315092382398562_close,
            act_2248226175642056_closeComponent_4498,
            evh_2248226175642056_close_4497,
            evh_2248226175642056_close,
            act_1040167445267876_setData_4502,
            evh_1040167445267876_success_4501,
            act_1040167445267876_request_4500,
            evh_1040167445267876_submit_4499,
            evh_1040167445267876_submit,
            act_4963030162390099_setData_4504,
            evh_4963030162390099_optionSelected_4503,
            act_4963030162390099_setData_4506,
            evh_4963030162390099_optionSelected_4505,
            evh_4963030162390099_optionSelected,
            act_3855552110905499_setData_4508,
            evh_3855552110905499_changed_4507,
            evh_3855552110905499_changed,
            act_4246589045129675_setData_4510,
            evh_4246589045129675_optionSelected_4509,
            act_4246589045129675_setData_4512,
            evh_4246589045129675_optionSelected_4511,
            act_4246589045129675_setData_4514,
            evh_4246589045129675_optionSelected_4513,
            evh_4246589045129675_optionSelected,
            act_353388685162594_closeComponent_4516,
            evh_353388685162594_clickPreventStop_4515,
            evh_353388685162594_clickPreventStop,
            act_1548630417156826_closeComponent_4518,
            evh_1548630417156826_clickPreventStop_4517,
            evh_1548630417156826_clickPreventStop,
            submit: act_1040167445267876_request_4500,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "lg",
    }),
    __metadata("design:type", String)
], ReplaceMeter.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], ReplaceMeter.prototype, "onSize", null);
ReplaceMeter = __decorate([
    (0, vue_property_decorator_1.Component)()
], ReplaceMeter);
exports.default = ReplaceMeter;
vue_property_decorator_1.Vue.component("ReplaceMeter", ReplaceMeter);
